import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Row, Col, BreadcrumbItem } from 'reactstrap';

const Breadcrumb = props => {
	return (
		<Row>
			<Col xs={12}>
				<div className="page-title-box d-sm-flex align-items-center justify-content-between">
					<h5 className="mb-sm-0 font-size-13">{props.breadcrumbItem}</h5>
					<div className="page-title-right">
						<ol className="breadcrumb m-0">
							<BreadcrumbItem>
								<Link to={props.titleLink ? props.titleLink : ''}>{props.title}</Link>
							</BreadcrumbItem>
							<BreadcrumbItem active>{props.breadcrumbItem}</BreadcrumbItem>
						</ol>
					</div>
				</div>
			</Col>
		</Row>
	);
};

Breadcrumb.propTypes = {
	breadcrumbItem: PropTypes.string,
	title: PropTypes.string,
	titleLink: PropTypes.string
};

export default Breadcrumb;
